export const 
AUTH_ROLES = {
    CASHIER:'cashier',
    ADMIN: 'admin',
    SUPER_ADMIN:'superAdmin',
    BOSS:'boss'
}